import { z } from 'zod';

export const cardCompareSchema = z.object({
    value: z.number(),
    abs: z.number(),
    pct: z.number().nullable(),
});
